import FanLivesSwiper from "./FanLivesSwiper";

export default FanLivesSwiper;
